export const TOKEN_NAME = 'alseco-aop-token';
export const REFRESH_TOKEN_NAME = 'alseco-aop-token-refresh';
// ID корневой папки со всеми процессами
export const PROCCESSES_BASE_FOLDER_ID = 'e9c6159f-5280-496a-8974-52722fa6efe8';
// ID корневой папки со всеми заявками
export const REQUEST_BASE_FOLDER_ID = '2be12143-72b2-4d0f-9d19-5569ea5b780a';
//ID блока обязательных файлов
export const BLOCK_FILES_REQUIRED = 'requestFiles';

export const BLOCK_RES_FILES = 'resFiles';

export const ID_PROCESS_SEND_INDICATIONS = 'PowerIndicationsSend';
export const TYPE_PROCESS_TARIFF_CHANGE = 'Изменение тарифа';
export const TYPE_PROCESS_SEAL_INSTALL = 'Опломбирование ПУ';

export const COOKIE_KEY_LOCALE = 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE';

export const BLOCK_METER_INDICATIONS_DATA = 'meterIndicationsData';
export const BLOCK_METER_INDICATIONS = 'meterIndications';
export const BLOCK_METER_INDICATIONS_DAY = 'meterIndicationsDay';
export const BLOCK_METER_INDICATIONS_NIGHT = 'meterIndicationsNight';

export const BLOCK_METER_INDICATIONS_DATA_ONE = 'meterIndicationsDataOne';
export const BLOCK_METER_INDICATIONS_DATA_TWO = 'meterIndicationsDataTwo';

export const ACTION_VALUE_CANCEL = 'cancel';

//excluded blocks to sign
export const BLOCK_MAIN_DATA = 'mainData';
export const BLOCK_ANSWER_DATA = 'answerData';

// обозначение ролей
// roleConsumers: Потребители (физические лица)
// roleUsersROES: Сотрудники РОЭС
// roleUsersRES: Сотрудники РЭС
export const ROLE_CONSUMERS = 'roleConsumers';
export const ROLE_USERS_ROES = 'roleUsersROES';
export const ROLE_USERS_RES = 'roleUsersRES';

//statuses
export const STATUS_DRAFT = 'Черновик';
export const STATUS_CONSIDERING = 'На рассмотрении'

export const BPM_DECISION_PROPERTY_NAME = 'COND___decision';

// кодовое обозначение корневой папки пользователя
export const FOLDER_CODENAME_USER_FOLDER = 'userFolder';
// кодовое обозначение папки для заявок пользователя
export const FOLDER_CODENAME_USER_PROCESS_FOLDER = 'userProcessFolder';

export const INACTIVE_USER_TIME_THRESHOLD = 300000;
export const USER_ACTIVITY_THROTTLER_TIME = 1000;

